import type { Maybe } from '@adornis/base/utilTypes.js';
import { DataLoadedField } from '@adornis/baseql/decorators/data-loaded-field.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { AdornisEntity } from '@adornis/baseql/entities/adornisEntity.js';
import { Mitarbeiter } from '../../master-data-management/users/entities/Mitarbeiter.js';

@Entity()
export class TeamMeetingAttendance extends AdornisEntity {
  public static override _class = 'TeamMeetingAttendance';

  static override resolveID(entity: any): string {
    return entity.userID;
  }

  @DataLoadedField(() => Mitarbeiter, ({ userID }) => userID)
  public employee: Maybe<Mitarbeiter>;

  @Field(() => String)
  public userID: Maybe<string>;
}
